export default [
    {
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/oils/Aisin.jpg",
        title:"زيت أيسن"
    },
    {
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/oils/Castrol.jpg",
        title:"زيت كاسترول"
    },
    {
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/oils/Mobil.jpg",
        title:"زيت موبيل"
    },
    {
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/oils/Shell.jpg",
        title:"زيت شيل"
    },
    {
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/oils/Total.jpg",
        title:"زيت توتال"
    }
];


// WEBPACK FOOTER //
// ./src/data/oilData.js